import { IIconProps, ISearchBoxStyles, SearchBox } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { LanguageContext } from "../../../utilities/LocalizationModule";

const filterIcon: IIconProps = { iconName: "PageListFilter" };
const searchBoxStyles: Partial<ISearchBoxStyles> = {
  root: { width: 300, height: "100%" }
};

export const useMenuItem_QuickFilter = (setQuickFilterValue: (filterValue: string) => void) => {
  const languageStrings = React.useContext(LanguageContext);

  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue?.value);
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);

  const [privateQuickFilterValue, setPrivateQuickFilterValue] = React.useState<string>();

  React.useEffect(() => {
    resetQuickFilterValue();
  }, [searchValue, currentDirectory]);

  React.useEffect(() => {
    const timeOutId = setTimeout(() => {
      setQuickFilterValue(privateQuickFilterValue?.trim());
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [privateQuickFilterValue]);

  const onChangeFilter = React.useCallback((event?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => {
    setPrivateQuickFilterValue(newValue);
  }, []);

  const onSearchFilter = React.useCallback((filterText: any) => {
    setQuickFilterValue(filterText?.trim());
  }, []);

  const onClearFilter = React.useCallback(() => {
    setQuickFilterValue("");
  }, []);

  const resetQuickFilterValue = React.useCallback(() => {
    setPrivateQuickFilterValue(null);
    setQuickFilterValue(null);
  }, []);

  const onMenuItem_QuickFilterRender = React.useCallback(() => {
    return <SearchBox
      styles={searchBoxStyles}
      placeholder={languageStrings.FilterResults}
      iconProps={filterIcon}
      underlined={true}
      value={privateQuickFilterValue ?? ""}
      onChange={onChangeFilter}
      onSearch={onSearchFilter}
      onClear={onClearFilter}
      showIcon={true}
    />
  }, [privateQuickFilterValue]);

  const menuItem_QuickFilter = React.useMemo(() => ({
    key: "QuickFilter",
    onRender: onMenuItem_QuickFilterRender
  }), [privateQuickFilterValue]);

  return {
    menuItem_QuickFilter,
    resetQuickFilterValue
  }
}